// extracted by mini-css-extract-plugin
export default {"paginacao":"Paginacao_paginacao__qImAG","active":"Paginacao_active__1dl8P","info":"Paginacao_info__NbVh5","table_logins":"Paginacao_table_logins__HMkGw"};